var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alignment"},[[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"text-xs-left",attrs:{"xs6":""}},[_c('h3',{staticClass:"styleHeader"},[_vm._v("\n          "+_vm._s(_vm.$t("pages.Customer.Index.Committente"))+"\n        ")])]),_c('v-flex',[_c('router-link',{attrs:{"to":_vm.$i18nRoute({ name: 'CustomerCreate' })}},[_c('v-btn',{staticClass:"right white--text styleHeader styleAlignamentAddButton",attrs:{"color":"#279947"}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("add")]),_vm._v("\n            "+_vm._s(_vm.$t("pages.Customer.Index.Aggiungi"))+"\n          ")],1)],1)],1)],1),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":[
        {
          text: this.currentLanguage.t('pages.Customer.Index.Nome'),
          value: 'name'
        },
        {
          text: this.currentLanguage.t('pages.Customer.Index.Sito'),
          value: 'stockName'
        },
        {
          text: this.currentLanguage.t('pages.Customer.Index.CodiceSocieta'),
          value: 'codiceSocieta'
        },
        {
          text: this.currentLanguage.t(
            'pages.Customer.Index.CodiceGestionale'
          ),
          value: 'codiceAS'
        },
        { text: '' }
      ],"items":_vm.customers},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.name))]),_c('td',[_vm._v(_vm._s(props.item.stockName))]),_c('td',[_vm._v(_vm._s(props.item.codiceSocieta))]),_c('td',[_vm._v(_vm._s(props.item.codiceAS))]),_c('td',[_c('v-btn',{staticClass:"right",attrs:{"flat":"","icon":""},on:{"click":function($event){return _vm.editItem(props.item)}}},[_c('v-icon',[_vm._v("edit")])],1)],1)]}}])})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }